import * as $ from 'jquery';

export class ProductsMeta {

    static refresh(title: string, description: string) {
        if (title) {
            $('meta[name="title"]').attr('content', title);
            $('meta[property="og:title"]').attr('content', title);
        }
        if (description) {
            $('meta[name="description"]').attr('content', description);
            $('meta[property="og:description"]').attr('content', description);
        }
    }


}